import { useRef } from 'react';

/**
 * GroupListItem Component
 *
 * @param group
 * @returns {JSX.Element}
 * @constructor
 */
const GroupListItem = ({ group }) => {
  // This is initially the number of actual answer docs in the db that this player has not answered
  const unAnsweredCountRef = useRef(group.unanswered_count);

  /**
   * onGroupClick
   *
   * Handler for the item click. Redirects to the stats page if all questions have been answered, otherwise
   * redirects to the play page.
   */
  const onGroupClick = () => {
    if (unAnsweredCountRef.current === 0) {
      window.location = '/stats/' + group.guid;
    } else {
      window.location = '/play/' + group.guid;
    }
  }

  // Get the number of unanswered questions for today
  if (group.todays_answers.length === 0) {
    // This just means today's question have not been generated yet
    unAnsweredCountRef.current += Number(process.env.REACT_APP_DAILY_QUESTION_COUNT);
  }

  return (
    <div className="group-list-item" guid={group.guid} onClick={onGroupClick}>
      <div className="group-list-left">
        <div className="group-list-item-subject">{group.subject}</div>
        {group.players.filter((player) => player.status === undefined || player.status === 'active').length === 1 &&
          <div className="group-list-item-player-count">
            <span className="group-list-players">Solo, day {group.day}</span>
          </div>
        }
        {group.players.filter((player) => player.status === undefined || player.status === 'active').length > 1 &&
          <div className="group-list-item-player-count">
            <span className="group-list-players">{group.players.filter((player) => player.status === undefined || player.status === 'active').length} players, day {group.day}</span>
          </div>
        }
      </div>
      {unAnsweredCountRef.current > 0 &&
        <div className="group-list-questions">{unAnsweredCountRef.current} new</div>
      }
      <div className="group-list-right">
        <div className="group-list-item-status">{unAnsweredCountRef.current > 0 ?
          <div><img src="/icon2.svg" alt="new" className="group-list-item-icon group-list-item-icon-question-mark"/></div> :
          <div><img src="/checkmark_icon.svg" alt="new" className="group-list-item-icon group-list-item-icon-check"/></div>}</div>
        <div className="clear-fix"/>
      </div>
    </div>
  )
}

export default GroupListItem;
